import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetOrderSummaryListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);

    if (!data) {
        return null;
    }

    const orderType = selectOrderType(data);

    return (
        <ListViewItem
            data-testid="order-status-header-summary"
            title={translate(`asset_summary_modal_header_${orderType ?? assetType}`)}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.ORDER_SUMMARY);
                onClose?.();
            }}
        />
    );
};

export const AssetOrderSummaryAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetOrderSummaryListItem key="order-summary-list-item" {...props} />;
};
